import React, { ReactElement, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { trySilentRefresh } from "@/api/session";

type Props = {
  children: ReactElement;
};

type GateState = "loading" | "authed" | "anon";

export const AuthGate = ({ children }: Props): ReactElement => {
  const [state, setState] = useState<GateState>("loading");

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (localStorage.getItem("token")) {
        if (!cancelled) setState("authed");
        return;
      }
      const ok = await trySilentRefresh();
      if (!cancelled) setState(ok ? "authed" : "anon");
    }

    void run();

    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "loading") return <></>;
  if (state === "anon") return <Navigate to="/login" replace />;
  return <>{children}</>;
};

